module.exports = __webpack_public_path__ + "static/media/icon-invites.f9333b8c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/icon-invites.svg
 ** module id = 2349
 ** module chunks = 44
 **/